import { useColorModeValue } from '@chakra-ui/react';

export default function useColors() {
  return {
    text: {
      'default': useColorModeValue('gray.700', 'gray.300'),
      active: useColorModeValue('blue.900', 'blue.200'),
      hover: useColorModeValue('blue.800', 'blue.200'),
    },
    bg: {
      'default': 'transparent',
      active: useColorModeValue('blue.50', 'blue.900'),
    },
    border: {
      'default': 'divider',
      active: useColorModeValue('blue.100', 'blue.800'),
    },
  };
}
